import { render, staticRenderFns } from "./editCollegeBanner.vue?vue&type=template&id=56ca8a44&scoped=true&"
import script from "./editCollegeBanner.vue?vue&type=script&lang=js&"
export * from "./editCollegeBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ca8a44",
  null
  
)

export default component.exports